import * as preact from "preact";
import PropTypes from "prop-types";

import classname from "../../../foundation/utils/classname";
import FormField from "../FormField";

import "./style.css";

const { h } = preact;

class TextFormField extends preact.Component {
    state = {
        error: null,
        isFocused: false
    }

    get shouldDisplayCountDown() {
        const { maxLength, shouldDisplayCountDown } = this.props;
        const { isFocused } = this.state;

        return shouldDisplayCountDown && Boolean(maxLength) && isFocused;
    }

    get remainingCharCount() {
        const { maxLength, value } = this.props;

        return maxLength - value.length;
    }

    handleChange = event => {
        const { name, onChange, validate } = this.props;
        const newValue = event.target.value;

        if (validate) {
            this.setState({
                error: validate(name, newValue)
            });
        }

        if (onChange) {
            onChange(name, newValue);
        }
    }

    handleFocus = () => {
        this.setState({
            isFocused: true
        });

        const { onFocus, name } = this.props;
        if (onFocus) {
            onFocus(name);
        }
    }

    handleBlur = () => {
        const { name, value, validate, onBlur } = this.props;

        if (validate) {
            this.setState({
                error: validate(name, value),
                isFocused: false
            });
        } else {
            this.setState({
                isFocused: false
            });
        }

        if (onBlur) {
            onBlur();
        }
    }

    handleKeyDown = event => {
        const { name, onEscape, onEnter } = this.props;

        if (event.keyCode === Zeplin.KEY_CODE.ESC) {
            event.preventDefault();
            event.target.blur();

            if (onEscape) {
                onEscape(name);
            }
        } else if (event.keyCode === Zeplin.KEY_CODE.ENTER && onEnter) {
            event.preventDefault();
            event.target.blur();
            onEnter();
        }
    }

    render() {
        const { error, isFocused } = this.state;
        const {
            name,
            class: cssClass,
            label,
            labelWidth,
            value,
            placeholder,
            customSuccessMessage,
            customErrorMessage,
            tipText,
            pendingText,
            nativeProps,
            maxLength,
            rows,
            disabled,
            autoFocus,
            shouldAlwaysDisplayTipText,
            isPending,
            adornment
        } = this.props;

        return (
            <FormField
                class={classname("textFormField", cssClass, { hasCountDown: this.shouldDisplayCountDown, hasAdornment: adornment })}
                label={label}
                labelWidth={labelWidth}
                successMessage={!this.shouldDisplayCountDown && customSuccessMessage}
                errorMessage={!this.shouldDisplayCountDown && (customErrorMessage || error)}
                tipText={tipText}
                pendingText={pendingText}
                disabled={disabled}
                shouldDisplayErrorMessageIcon={Boolean(value)}
                shouldDisplayTipText={isFocused || shouldAlwaysDisplayTipText}
                isPending={isPending}>
                <div class="formFieldInput">
                    {rows ? (
                        <textarea
                            name={name}
                            value={value}
                            placeholder={placeholder}
                            maxlength={maxLength}
                            rows={rows}
                            autocomplete="off"
                            autoFocus={autoFocus}
                            disabled={disabled}
                            onChange={this.handleChange}
                            onFocus={this.handleFocus}
                            onBlur={this.handleBlur}
                            onKeyDown={this.handleKeyDown}
                            {...nativeProps}/>
                    ) : (
                        <input
                            class="ellipsis"
                            name={name}
                            value={value}
                            placeholder={placeholder}
                            autocomplete="off"
                            maxlength={maxLength}
                            autoFocus={autoFocus}
                            disabled={disabled}
                            onChange={this.handleChange}
                            onFocus={this.handleFocus}
                            onBlur={this.handleBlur}
                            onKeyDown={this.handleKeyDown}
                            {...nativeProps}/>
                    )}
                    {adornment && <div class="adornment" tabIndex={-1}>{adornment}</div>}
                </div>
                {this.shouldDisplayCountDown && <div class={classname("countDown", { exceed: this.remainingCharCount === 0 })}>{this.remainingCharCount}</div>}
            </FormField>
        );
    }
}

TextFormField.propTypes = {
    name: PropTypes.string.isRequired,
    class: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    customSuccessMessage: PropTypes.node,
    customErrorMessage: PropTypes.node,
    tipText: PropTypes.node,
    pendingText: PropTypes.string,
    nativeProps: PropTypes.object,
    maxLength: PropTypes.number,
    rows: PropTypes.number,
    disabled: PropTypes.bool,
    autoFocus: PropTypes.bool,
    shouldDisplayCountDown: PropTypes.bool,
    shouldAlwaysDisplayTipText: PropTypes.bool,
    isPending: PropTypes.bool,
    adornment: PropTypes.node,
    onChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onEscape: PropTypes.func,
    onEnter: PropTypes.func,
    validate: PropTypes.func
};

TextFormField.defaultProps = {
    value: "",
    shouldDisplayCountDown: true
};

export default TextFormField;
